/* eslint-disable react/prop-types */
import { Box, Divider, Grid, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import moment from "moment-timezone";
import { removeUnderscore } from "../../../utils/removedUnderScore";

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = moment(dateStr, "YYYYMMDD");
  return date.isValid() ? date.format("MMM DD, YYYY") : dateStr;
};

const Field = ({ label, value }) => {
  const isDateField = label.toUpperCase().endsWith("DATE");
  return (
    <Grid templateColumns="135px 1fr" gap={2}>
      <Text fontSize="sm">{removeUnderscore(label)}</Text>
      <Text fontSize="sm">
        : {isDateField ? formatDate(value) : value ?? "-"}
      </Text>
    </Grid>
  );
};

const PersonDetails = ({ person }) => {
  return (
    <Box>
      <SimpleGrid columns={2} gap={2}>
        <Box>
          {" "}
          {/* Basic Fields */}
          <VStack align="stretch" spacing={1}>
            <Field label="SSN" value={person.SSN} />
            <Field label="Deduplication" value={person.DEDUPLICATION} />
          </VStack>
          <SimpleListSection title="Tribes" items={person.TRIBE} />
          <SimpleListSection title="Races" items={person.RACE} />
          <ArraySection title="History" items={person.HISTORY} />
        </Box>
        <Box>
          {" "}
          <ArraySection title="Addresses" items={person.ADDRESS} />
        </Box>
      </SimpleGrid>
    </Box>
  );
};

export default PersonDetails;

/**
 * For simple string arrays (Tribe, Race, Links)
 */
const SimpleListSection = ({ title, items }) => {
  if (!items || items.length === 0) {
    return (
      <Box mt={1}>
        <Text fontWeight="bold">{title}</Text>
        <Text>No {title.toLowerCase()} available</Text>
      </Box>
    );
  }

  return (
    <Box>
      <Text fontWeight="bold">{title}</Text>
      <VStack align="start" pl={2}>
        {items.map((item, index) => (
          <Text key={index} fontSize="sm">
            • {item}
          </Text>
        ))}
      </VStack>
    </Box>
  );
};

/**
 * For structured arrays (Address, History, Cases)
 */
const ArraySection = ({ title, items }) => {
  if (!items || items.length === 0) {
    return (
      <Box>
        <Text fontWeight="bold" mb={1}>
          {title}
        </Text>
        <Text>No {title.toLowerCase()} available</Text>
      </Box>
    );
  }

  return (
    <Box>
      <Text fontWeight="bold" mb={1}>
        {title}
      </Text>

      {items.map((item, index) => (
        <Box key={index}>
          {Object.entries(item).map(([key, value]) => {
            if (Array.isArray(value)) {
              return (
                <Box key={key}>
                  <Text>{removeUnderscore(key)}:</Text>
                  <VStack align="start" pl={4}>
                    {value.map((v, i) => (
                      <Text key={i} fontSize="sm">
                        - {v}
                      </Text>
                    ))}
                  </VStack>
                </Box>
              );
            } else {
              return <Field key={key} label={key} value={value} />;
            }
          })}
          <Divider my={2} borderColor="gray.300" />
        </Box>
      ))}
    </Box>
  );
};
